import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';



import BICNY from '../../assets/orgLogo/BICNY.png';
import DarulJannah from '../../assets/orgLogo/DarulJannah.png';
import GroupMenuCenter from '../../assets/orgLogo/GroupMenuCenter.png';
import MenuCenter from '../../assets/orgLogo/MenuCenter.png';
import QDCLogo from '../../assets/orgLogo/QDC_Logo.png';
import MasjidTauheed from '../../assets/orgLogo/MasjidTauheed.png';
import MasjidBaitusSlam from '../../assets/orgLogo/MasjidBaitusSlam.png';
import DEENCONNECT_HHC_Logo from '../../assets/orgLogo/DEENCONNECT_HHC_Logo.png';
class Slider extends React.Component {
    render() {
        return (
            // <Carousel autoPlay>
            //     <div className="carousel-images">
            //         <a href="#"><img className="orgLogos" src={QDCLogo} alt="slider" /></a>
            //         <a href="#"><img src={BICNY} /></a>
            //         <a href="#"><img src={DarulJannah} alt="slider" /></a>
            //         <a href="#"><img src={MenuCenter} alt="slider" /></a>
            //         <a href="#"><img src={GroupMenuCenter} alt="slider" /></a>
            //         <a href="#"><img src={ZamzamHajj} alt="slider" /></a>
            //     </div>
            // </Carousel>

            <div className="carousel-images">
                    <a href="https://alqurandc.org/" target='_blank'><img src={QDCLogo} alt="slider" /></a>
                    <a href="https://dev.bicny.org/" target='_blank'><img src={BICNY} /></a>
                    <a href="https://daruljannah.org/" target='_blank'><img src={DarulJannah} alt="slider" /></a>
                    <a href="https://masjidtauheed.org" target='_blank'><img src={MasjidTauheed} alt="slider" /></a>
                    <a href="#" target='_blank'><img src={GroupMenuCenter} alt="slider" /></a>
                    <a href="https://hhcusa.org" target='_blank'><img src={DEENCONNECT_HHC_Logo} alt="slider" /></a>
                    <a href="https://www.baitussalamny.org" target='_blank'><img src={MasjidBaitusSlam} alt="slider" /></a>
                </div>
        )
    }
}

export default Slider;
